import type { MarkNotificationAsRead200SourceSourceUser } from './markNotificationAsRead200SourceSourceUser';

export type MarkNotificationAsRead200Source = {
  sourceUser?: MarkNotificationAsRead200SourceSourceUser;
  /** @nullable */
  sourceUserId?: number | null;
};
